import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import BreadcrumbExtend from "../../../../components/BreadcrumbExtend";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import {Link} from "react-router-dom";
import {daliHelvarActions} from "../../../../actions/dali-helvar.actions";
import {Button} from "react-bootstrap";
import DaliHelvarSceneForm from "./_forms/DaliHelvarSceneForm";
import {modalActions} from "../../../../actions/modal.actions";
import DaliHelvarSceneTable from "./_components/DaliHelvarSceneTable";
import DaliDeviceInfo from "../_components/DaliDeviceInfo";

class DaliHelvarScenePage extends Component {

    areaId = null;
    groupId = null;
    networkDeviceId = null;


    componentDidMount() {
        const { id, groupId, areaId } = this.props.match.params;
        const { dispatch } = this.props;

        this.networkDeviceId = parseInt(id);
        this.groupId = parseInt(groupId);
        this.areaId = parseInt(areaId);


        dispatch(daliHelvarActions.getHelvarGroupById(this.groupId));
        dispatch(daliHelvarActions.getHelvarScenes(this.groupId));
        dispatch(daliHelvarActions.getHelvarAreaById(this.areaId));
        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(this.networkDeviceId));
    }

    openModalCreateHelvarScene = (e) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_dali-group'),
            component: <DaliHelvarSceneForm daliHelvarGroupId={this.groupId} submitForm={this.handleSubmitCreateHelvarScene}/>
        };
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}))
    };

    handleSubmitCreateHelvarScene = (model) => {
        const { dispatch } = this.props;
        dispatch(daliHelvarActions.createHelvarScene(model));
    };

    render() {
        const { t, simpleDeviceInfo, helvarSceneList, helvarGroupItem, helvarAreaItem } = this.props;

        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: simpleDeviceInfo?.label, path: '#' },
            { value: `${t('area')} - ${helvarAreaItem?.label}`, path: `/panel/network-device/dali/helvar/${this.id}/area` },
            { value: `${t('dali-group')} - ${helvarGroupItem?.label}`, path: `/panel/network-device/dali/helvar/${this.id}/group/${this.groupId}` },
            { value: `${t('dali-scene')}`, path: "#" },
        ];

        const extendInfo = [
            { key: 'area', value: helvarAreaItem?.label },
            { key: 'group', value: helvarGroupItem?.label }
        ];


        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <DaliDeviceInfo networkDeviceInfo={simpleDeviceInfo} title={'dali-scene'} infoElements={extendInfo}/>

                <div className="card">
                    <div className="card-header">
                        <div className="button-group float-right">
                            <Button variant={"success"} onClick={this.openModalCreateHelvarScene}>
                                <i className="fas fa-plus"/> {t('create')}
                            </Button>
                            &nbsp;
                            <Link to={`/panel/network-device/dali/helvar/${simpleDeviceInfo?.id}/groups/${this.areaId}`} className="btn btn-secondary">
                                <i className="fas fa-undo"> </i> {t('back-to-group')}
                            </Link> &nbsp;
                        </div>
                    </div>
                    <div className="card-body">
                        <DaliHelvarSceneTable list={helvarSceneList} />
                    </div>
                </div>

            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { simpleDeviceInfo} = state.networkDeviceReducer;
    const { helvarSceneList, helvarGroupItem, helvarAreaItem } = state.daliHelvarReducer;
    return {
        helvarSceneList,
        helvarGroupItem,
        simpleDeviceInfo,
        helvarAreaItem
    }
};
export default withNamespaces()(connect(mapStateToProps)(DaliHelvarScenePage));
